import { render, staticRenderFns } from "./soporte_menu.vue?vue&type=template&id=4131cb29&scoped=true"
import script from "./soporte_menu.vue?vue&type=script&lang=js"
export * from "./soporte_menu.vue?vue&type=script&lang=js"
import style0 from "./soporte_menu.vue?vue&type=style&index=0&id=4131cb29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4131cb29",
  null
  
)

export default component.exports